document.addEventListener('DOMContentLoaded', function () {
  const content = document.querySelector('.blog-post-content');
  const tocList = document.getElementById('toc-list');
  const tocWrapper = document.getElementById('article-toc');
  if (!content || !tocList || !tocWrapper) return;

  const headings = content.querySelectorAll('h2, h3, h4, h5');
  if (headings.length === 0) {
    tocWrapper.style.display = 'none';
    return;
  }

  headings.forEach(function (heading, index) {
    if (!heading.id) {
      const slug = heading.textContent
        .toLowerCase()
        .trim()
        .replace(/[^a-z0-9\s-]/g, '')
        .replace(/\s+/g, '-');
      heading.id = slug + '-' + index;
    }

    const level = parseInt(heading.tagName.substring(1), 10);
    const link = document.createElement('a');
    link.href = '#' + heading.id;
    link.textContent = heading.textContent;
    link.className = 'blog-post-toc__link blog-post-toc__link--h' + level;
    link.addEventListener('click', function (e) {
      e.preventDefault();
      document.getElementById(heading.id).scrollIntoView({ behavior: 'smooth', block: 'start' });
    });

    tocList.appendChild(link);
  });
});